<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToChineesStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/chinees/Asset 7.png" alt="">
    <img draggable="false" id="obj__1" src="./../../assets/images/chinees/Asset 5.png" alt="">
    <img draggable="false" id="obj__2" src="./../../assets/images/chinees/Asset 4.png" alt="">

    <span v-for="(card, index) in cards" :key="card">
      <div v-if="card.image_id === 19" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 19.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 17" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 17.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 8" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 8.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 13" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 13.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 18" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 18.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 16" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 16.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 12" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 12.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 14" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 14.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 9" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 9.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 10" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 10.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 11" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 11.png" alt="">
          </div>
        </div>
      </div>

      <div v-if="card.image_id === 15" class="flip-card card__" :id="`card__${index}`" @click="flipCard(card.id)">
        <div class="flip-card-inner" :class="{ 'flip-card-inner-rotated': card.flipped }">
          <div class="flip-card-front">
            <img draggable="false" class="clickable card_group card__" src="./../../assets/images/chinees/Asset 30.png" alt="">
          </div>
          <div class="flip-card-back">
            <img draggable="false" class="cursor card_group card__" src="./../../assets/images/chinees/Asset 15.png" alt="">
          </div>
        </div>
      </div>

    </span>
    
  </span>
</template>

<script>
// Puzzle code
// https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_flip_card

import swal from 'sweetalert2'

export default {
  name: "ChineesGame",
  mounted() {
    this.randomizeCards()
  },

  created() {},
  destroyed() {},

  data() {
    return {
      flipping_disabled: false,
      flipped_cards: [],
      cards: [],
      template_cards: [
        {
          id: 1,
          group_id: 1,
          image_id: 19,
          flipped: false,
          disabled: false,
        },
        {
          id: 2,
          group_id: 2,
          image_id: 17,
          flipped: false,
          disabled: false,
        },
        {
          id: 3,
          group_id: 3,
          image_id: 8,
          flipped: false,
          disabled: false,
        },
        {
          id: 4,
          group_id: 4,
          image_id: 13,
          flipped: false,
          disabled: false,
        },
        {
          id: 5,
          group_id: 5,
          image_id: 18,
          flipped: false,
          disabled: false,
        },
        {
          id: 6,
          group_id: 6,
          image_id: 16,
          flipped: false,
          disabled: false,
        },
        {
          id: 7,
          group_id: 7,
          image_id: 12,
          flipped: false,
          disabled: false,
        },
        {
          id: 8,
          group_id: 8,
          image_id: 14,
          flipped: false,
          disabled: false,
        },
        {
          id: 9,
          group_id: 9,
          image_id: 9,
          flipped: false,
          disabled: false,
        },
        {
          id: 10,
          group_id: 10,
          image_id: 10,
          flipped: false,
          disabled: false,
        },
        {
          id: 11,
          group_id: 11,
          image_id: 11,
          flipped: false,
          disabled: false,
        },
        {
          id: 12,
          group_id: 12,
          image_id: 15,
          flipped: false,
          disabled: false,
        },
        {
          id: 13,
          group_id: 1,
          image_id: 19,
          flipped: false,
          disabled: false,
        },
        {
          id: 14,
          group_id: 2,
          image_id: 17,
          flipped: false,
          disabled: false,
        },
        {
          id: 15,
          group_id: 3,
          image_id: 8,
          flipped: false,
          disabled: false,
        },
        {
          id: 16,
          group_id: 4,
          image_id: 13,
          flipped: false,
          disabled: false,
        },
        {
          id: 17,
          group_id: 5,
          image_id: 18,
          flipped: false,
          disabled: false,
        },
        {
          id: 18,
          group_id: 6,
          image_id: 16,
          flipped: false,
          disabled: false,
        },
        {
          id: 19,
          group_id: 7,
          image_id: 12,
          flipped: false,
          disabled: false,
        },
        {
          id: 20,
          group_id: 8,
          image_id: 14,
          flipped: false,
          disabled: false,
        },
        {
          id: 21,
          group_id: 9,
          image_id: 9,
          flipped: false,
          disabled: false,
        },
        {
          id: 22,
          group_id: 10,
          image_id: 10,
          flipped: false,
          disabled: false,
        },
        {
          id: 23,
          group_id: 11,
          image_id: 11,
          flipped: false,
          disabled: false,
        },
        {
          id: 24,
          group_id: 12,
          image_id: 15,
          flipped: false,
          disabled: false,
        }
      ],
    };
  },

  methods: {
    goToChineesStart() {
      this.$router.push('/chinees/start');
    },

    goToChineesHoro() {
      this.$router.push('/chinees/horo');
    },

    flipCard(card_id) {
      if ( ! this.flipping_disabled ) {
        var that = this

        for (let index = 0; index < that.cards.length; index++) {
          if ( that.cards[index].id == card_id && that.cards[index].disabled == false ) {
            if ( that.cards[index].flipped == false ) {
              that.cards[index].flipped = true
              that.flipped_cards.push(that.cards[index]);
            } else {
              that.cards[index].flipped = false
              that.flipped_cards = [];
            }
          }

          if ( that.flipped_cards.length == 2 ) {
            // Check if cards match
            if ( that.flipped_cards[0].group_id == that.flipped_cards[1].group_id ) {
              that.flipped_cards[0].disabled = true;
              that.flipped_cards[1].disabled = true;
            }

            that.flipping_disabled = true
            setTimeout(function() {
              that.unFlipCards()
              that.flipping_disabled = false
              that.flipped_cards.length = 0
            }, 1500);
          }
        }
      }
    },

    unFlipCards() {
      var that = this
      for (let index = 0; index < that.cards.length; index++) {
        if ( that.cards[index].disabled == false ) {
          that.cards[index].flipped = false
        }
      }
    },

    resetGame() {
      this.flipping_disabled = false;
      this.flipped_cards = [];

      for (let index = 0; index < this.cards.length; index++) {
        this.cards[index].flipped = false
        this.cards[index].disabled = false
      }
    },

    endGame() {
      var that = this
      new swal({
          allowEscapeKey: false,
          allowOutsideClick: false,
          title: "",
          html: `<p class='swal_html'>Goed zo!</p>`,
          type: "success",
          showCancelButton: true,
          cancelButtonColor: '#d33',
          cancelButtonText: 'Ga door!',
          confirmButtonColor: "#9BCB3C",
          confirmButtonText: "Opnieuw spelen",
        }).then(function (confirm) {
          if ( confirm.isConfirmed ) {
            that.resetGame();
          } else {
            that.goToChineesHoro();
          }
        });
    },

    randomizeCards() {
      let arr = this.shuffle(this.template_cards);
      this.cards = arr;
    },

    shuffle(array) {
      let currentIndex = array.length,  randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex > 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    },
  },

  computed: {},
  watch: {
    cards: {
      handler: function (cards, oldVal) {
        let disabled_cards = 0
        for (let index = 0; index < cards.length; index++) {
          if ( cards[index].disabled == true ) disabled_cards++
        }
        // if (disabled_cards == 12) {
        if (disabled_cards == cards.length) {
          this.endGame()
        }
      },
      deep: true
    }
  }
};
</script>

<style>
  .flip-card {
    background-color: transparent;
    /* width: 200px; */
    /* height: 200px; */
    perspective: 1000px;
    position: absolute;
    /* margin-top: 33%; */
    /* left: 63.3%; */
    width: 10%;
    height: 10%;
  }

  .flip-card-inner {
    position: relative;
    /* width: 100%; */
    /* height: 100%; */
    text-align: center;
    transition: transform 0.6s;
    transform-style: preserve-3d;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  }

  /* .flip-card:hover .flip-card-inner {
    transform: rotateY(180deg);
  } */

  .flip-card-inner-rotated {
    transform: rotateY(180deg);
  }

  .flip-card-front, .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
  }

  .flip-card-front {
    background-color: #bbb;
    color: black;
  }

  .flip-card-back {
    background-color: white;
    color: white;
    transform: rotateY(180deg);
  }

  #chinees_start_btn {
    position: absolute;
    margin-top: 35%;
    left: 42.5%;
    width: 15%;
  }
  #obj__1 {
    position: absolute;
    margin-top: -2%;
    left: 8.5%;
    width: 15%;
  }
  #obj__2 {
    position: absolute;
    margin-top: -2%;
    left: 78%;
    width: 15%;
  }

  .card__ {
    width: 7%;
  }

  #card__0 {
    position: absolute;
    margin-top: 8%;
    left: 25%;
  }
  #card__1 {
    position: absolute;
    margin-top: 8%;
    left: 34%;
  }
  #card__2 {
    position: absolute;
    margin-top: 8%;
    left: 43%;
  }
  #card__3 {
    position: absolute;
    margin-top: 8%;
    left: 52%;
  }
  #card__4 {
    position: absolute;
    margin-top: 8%;
    left: 61%;
  }
  #card__5 {
    position: absolute;
    margin-top: 8%;
    left: 70%;
  }
  #card__6 {
    position: absolute;
    margin-top: 17%;
    left: 25%;
  }
  #card__7 {
    position: absolute;
    margin-top: 17%;
    left: 34%;
  }
  #card__8 {
    position: absolute;
    margin-top: 17%;
    left: 43%;
  }
  #card__9 {
    position: absolute;
    margin-top: 17%;
    left: 52%;
  }
  #card__10 {
    position: absolute;
    margin-top: 17%;
    left: 61%;
  }
  #card__11 {
    position: absolute;
    margin-top: 17%;
    left: 70%;
  }
  #card__12 {
    position: absolute;
    margin-top: 26%;
    left: 25%;
  }
  #card__13 {
    position: absolute;
    margin-top: 26%;
    left: 34%;
  }
  #card__14 {
    position: absolute;
    margin-top: 26%;
    left: 43%;
  }
  #card__15 {
    position: absolute;
    margin-top: 26%;
    left: 52%;
  }
  #card__16 {
    position: absolute;
    margin-top: 26%;
    left: 61%;
  }
  #card__17 {
    position: absolute;
    margin-top: 26%;
    left: 70%;
  }
  #card__18 {
    position: absolute;
    margin-top: 35.3%;
    left: 25%;
  }
  #card__19 {
    position: absolute;
    margin-top: 35.3%;
    left: 34%;
  }
  #card__20 {
    position: absolute;
    margin-top: 35.3%;
    left: 43%;
  }
  #card__21 {
    position: absolute;
    margin-top: 35.3%;
    left: 52%;
  }
  #card__22 {
    position: absolute;
    margin-top: 35.3%;
    left: 61%;
  }
  #card__23 {
    position: absolute;
    margin-top: 35.3%;
    left: 70%;
  }

  .card_group {
    width: 100%;
    -webkit-filter: drop-shadow(5px 5px 5px #707070);
    filter: drop-shadow(5px 5px 5px #707070);
  }
</style>


